import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { LaboratorioService } from '../laboratorio.service';

@Component({
  templateUrl: './visualizar-laboratorio.component.html',
})
export class VisualizarLaboratorioComponent extends WebPage implements OnInit {

  idLaboratorio;
  laboratorio;

  constructor(
    private route: ActivatedRoute,
    private arquivoService: ArquivoService,
    private laboratorioService: LaboratorioService,
    messageService: MessageService
  ) {
    super(messageService);

    this.route.paramMap.subscribe(params =>
      this.idLaboratorio = params.get('idLaboratorio')
    );
  }

  ngOnInit() {
    this.isLoading = true;
    this.laboratorioService.getFull(this.idLaboratorio)
      .finally(() => this.isLoading = false)
      .subscribe(
        laboratorio => this.laboratorio = laboratorio,
        error => this.gerenciaErro(error)
      );
  }

  downloadArquivo(idArquivo) {
    this.arquivoService.downloadArquivo(idArquivo, 'Documento_Laboratorio');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/laboratorio/visualizar-laboratorio/visualizar-laboratorio.component.ts